<div class="login-page">
  <mat-card>
    <!--<mat-card-title style="text-align:center;">Iniciar sesión</mat-card-title>-->
    <mat-card-content>
      <div class='imgBlock'>
        <img src="./../../assets/logo-blau.png" alt="RET DE RESIDUS" title="RET DE RESIDUS" class='logo'>
      </div>
      <h2>Iniciar sesión</h2>
      <form [formGroup]="loginForm">
        <mat-form-field appearance="outline" class='formField'>
          <mat-label>Email</mat-label>
          <input matInput placeholder="Email" formControlName="loginEmail" required>
          <mat-error>El email es obligatorio</mat-error>
          <mat-error>Debe ser un email valido</mat-error>
          <mat-icon matSuffix color="primary" >email</mat-icon>
        </mat-form-field>
        <mat-form-field appearance="outline" class='formField'>
          <mat-label>Contraseña</mat-label>
          <input matInput placeholder="Contraseña" formControlName="loginPassword" type="password" required>
          <mat-error>La contraseña es obligatoria</mat-error>
          <mat-error>Mínimo 8 caracteres</mat-error>
          <mat-icon matSuffix color="primary" >lock</mat-icon>
        </mat-form-field>
      </form>
      <mat-slide-toggle [(ngModel)]="saveCredentials" color='primary'>Recuerdame</mat-slide-toggle>
      <button mat-raised-button color="primary" class="login-button" (click)="iniciarSesion()"> Iniciar sesión</button>
      <div class='actionBlock pointer' routerLink="/recover">¿Has olvidado la contraseña?</div>
    </mat-card-content>
    @if (loading) {
      <div class='spinner'>
        <mat-spinner></mat-spinner>
      </div>
    }
  </mat-card>
</div>
